__turbopack_context__.v({
  "active": "navigation-bar-module-sass-module__7oAnRq__active",
  "base": "navigation-bar-module-sass-module__7oAnRq__base",
  "container": "navigation-bar-module-sass-module__7oAnRq__container",
  "gamesCount": "navigation-bar-module-sass-module__7oAnRq__gamesCount",
  "hasFavorite": "navigation-bar-module-sass-module__7oAnRq__hasFavorite",
  "hasFavourite": "navigation-bar-module-sass-module__7oAnRq__hasFavourite",
  "navItem": "navigation-bar-module-sass-module__7oAnRq__navItem",
  "navItemName": "navigation-bar-module-sass-module__7oAnRq__navItemName",
  "selected": "navigation-bar-module-sass-module__7oAnRq__selected",
  "sidebar": "navigation-bar-module-sass-module__7oAnRq__sidebar",
});
